exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, "\n.reservationBox[data-v-50e9d393] {\n  box-sizing: border-box;\n  font-size: 5vw;\n  background-color: white;\n  border-style: solid;\n  border-color: #0065B3;\n  position: absolute;\n  z-index: 999;\n  overflow: hidden;\n}\n.reservationBox[data-v-50e9d393]:hover {\n  overflow: visible;\n}\n.editButton[data-v-50e9d393] {\n  box-sizing: border-box;\n  background-color: white;\n  border-style: solid;\n  border-color: none;\n  display: inline;\n}\n.trial[data-v-50e9d393], .firstTime[data-v-50e9d393] {\n  background-color: #ddddff;\n}\n.grayedOut[data-v-50e9d393] {\n  border-color: #888888;\n  color: #888888;\n}\n", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader?{"minimize":false,"sourceMap":false}!./~/vue-loader/lib/style-compiler?{"id":"data-v-50e9d393","scoped":true,"hasInlineConfig":false}!./~/vue-loader/lib/selector.js?type=styles&index=0!./src/components/Mobile/timetable/boxes/SpReservationBox.vue
// module id = 513
// module chunks = 0